import { HttpClient, AMCFundStatusUtil } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";

class CAMCFundManager {
    constructor(fundCode) {
        this.httpClient = new HttpClient();
        this.fundCode = fundCode;
        this.$managerWrapper = $(".managers-wrapper");
        this.$fundManager = $(".fund-manager");
        this.$camcFundManager = $(".camc-fund-managers");
    }

    async render() {
        const options = {
            errorHandler: () => {
                this.errorHandler();
            },
            data: {
                fundCode: this.fundCode,
            },
        };
        const fundManagerData = await this.httpClient.get(FUND_API_SOURCES.MANAGERS_SOURCE, options);
        const displayedFundManagerData = await this.getDisplayManagerData(fundManagerData);

        this.renderFundManagerTemplate(displayedFundManagerData);
    }

    errorHandler() {}

    async getDisplayManagerData(fundManagerData) {
        // Guard clause
        if (!fundManagerData || !fundManagerData.data) return [];

        // Access cached fund status directly instead of using the async method
        const isActiveFund = await AMCFundStatusUtil.getFundStatus();

        // Process managers synchronously with filter+map instead of async map
        return fundManagerData.data
            .filter((item) => item.titleDisplayState != "HIDE")
            .map((item) => {
                // Create a copy to avoid mutating the original data
                const manager = { ...item };

                if (!isActiveFund) {
                    manager.title = "拟任基金经理";
                }
                return manager;
            });
    }

    cloneFundManagerSection(displayedFundManagerData) {
        for (let i = 1; i < displayedFundManagerData.length; i++) {
            this.$fundManager.first().clone().appendTo(this.$managerWrapper);
        }
    }

    renderNoneManagerTemplate() {
        this.$camcFundManager.hide();
    }

    renderOneManagerTemplate(displayedFundManagerData) {}

    renderMultiManagerTemplate(displayedFundManagerData) {}

    renderFundManagerTemplate(displayedFundManagerData) {
        this.cloneFundManagerSection(displayedFundManagerData);
        if (displayedFundManagerData.length > 1) {
            this.renderMultiManagerTemplate(displayedFundManagerData);
        } else if (displayedFundManagerData.length == 1) {
            this.renderOneManagerTemplate(displayedFundManagerData);
        }
        if (displayedFundManagerData.length == 0) {
            this.renderNoneManagerTemplate();
        }
    }
}

export default CAMCFundManager;
